import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { ConsultorService } from 'src/app/main/web-admin/services/consultor.service';
import { ErrorModel } from 'src/app/core/models/error.model';

@Component({
  selector: 'app-consultor',
  templateUrl: './consultor.component.html',
  styleUrls: ['./consultor.component.scss']
})
export class ConsultorComponent implements OnInit {

  formGroup: FormGroup = this.formBuilder.group({
    nome: ['', Validators.compose([Validators.required])],
    email: ['', Validators.compose([Validators.required])],
    cpf: ['', Validators.compose([Validators.required])],
  });

  messagem = null;

  constructor(
      private formBuilder: FormBuilder,
      private layoutService: LayoutService,
      private consultorService: ConsultorService
  ) { }

  ngOnInit(): void {
  }

  submitForm(): void {
    this.messagem = null;

    if (!this.formGroup.valid) {
      this.messagem = 'preencha todos os campos.';
      return;
    }

    this.layoutService.loading();

    this.consultorService.createAccess(this.formGroup.value).subscribe(() => {
      this.messagem = 'Acesso criado com sucesso para: ' + this.formGroup.get('email').value;
    }, (error: ErrorModel) => {
      console.log(error);
    }).add(() => {
      this.layoutService.loaded();
    });
  }

}
